module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<style>\n    .spl-form__page__upload > div {\n        margin : 5px 0;\n    }\n</style>\n<div class=\"form__page spl-form__page spl-form__page__upload\">\n    <div name=\"driver-options\" style=\"margin-bottom: 15px\"></div>\n    <div>\n        <p><label>\n            Выберите shapefile для импорта границ полей<br>\n            <input type=\"file\" name=\"files\" multiple on-change=\"onFileChange\"/>\n            </label></p>\n        <p style=\"color:red;\">Каждое поле должно быть отдельным векторным объектом для последующего заполнения паспорта!</p>\n    </div>\n</div>")
  }
  return __output.join("");

}